import { ReactNode, useId } from 'react';

import { HorizontalScroll } from '../HorizontalScroll';
import { Pagination, PaginationProps } from '../Pagination';

type Props = {
  enableForDesktop?: boolean;
  fullWidth?: boolean;
  label?: ReactNode;
} & Omit<PaginationProps, 'selectedHtmlId'>;

export function PaginationWithScroll({
  className,
  enableForDesktop,
  fullWidth,
  label,
  ...pagination
}: Props) {
  const selectedId = `${useId()}-${pagination.pageNum}`;
  const selectedSelector = '#' + selectedId;

  return (
    <HorizontalScroll
      className={className}
      fullWidth={fullWidth}
      enableForDesktop={enableForDesktop}
      scrollToSelector={selectedSelector}
    >
      {label}
      <Pagination {...pagination} selectedHtmlId={selectedId} />
    </HorizontalScroll>
  );
}
